import { Domain } from '../../store/modules/merchant/types';

export const testId = 'MERCHANT_DOMAINS';

/** Sample filler data for domains */
export const domainData: Domain[] = [
  {
    url: 'https://checkout-dev.gocartpay.com',
    isInherited: false,
    id: '2d7592b5-438b-46c4-af91-f2fb34776e7a',
  },
  {
    url: 'https://demo-storefront-dev.gocartpay.com',
    isInherited: false,
    id: '493af133-d992-4247-9a40-bc03b1be1399',
  },
  {
    url: 'https://shop.gocartpay.com',
    isInherited: false,
    id: 'd948d5e4-1b7f-4767-8177-94d07f5eb031',
  },
  {
    url: 'https://temp.space',
    isInherited: false,
    id: '06c9fc13-3e9d-42ff-bdca-28c2cc7c7246',
  },
];
